import AnalyticsHelper from '../../utils/analytics-helper.js';

export default class ModelDropdown {
    constructor(parent, router, primary) {
        this.router = router;
        this.primary = primary;
        this.el = parent.el.querySelector(primary ? '.select-primary' : '.select-secondary');
        this.param = this.el.dataset.param;
        this.select = this.el.querySelector('select');
        this.selected = this.el.querySelector('.select-selected');
        this.text = this.selected.querySelector('.text');
        this.none = this.text.innerHTML;
        this.list = this.el.querySelector('.select-item-list');
        this.items = this.list.querySelectorAll('.select-item');
        this.background = primary ? parent.background : null;
        if (primary && parent.el.querySelector('.select-secondary')) {
            this.child = new ModelDropdown(parent, router, false);
        } else {
            this.router.data.param = this.param;
            this.router.data.items = this.items;
        }

        this.bind();
    }

    bind() {
        this.selected.addEventListener('click', () => this.toggle());
        this.selected.addEventListener('keydown', (e) => {
            if (e.code === 'Enter') {
                this.toggle();
            } else if (e.code === 'ArrowDown' || e.code == 'ArrowUp') {
                e.preventDefault();
                this.openAndFocusFirst();
            } else if (e.code === 'Escape') {
                this.close();
            }
        });
        this.items.forEach((item) => {
            item.addEventListener('click', (e) => this.click(e.currentTarget));
            item.addEventListener('keydown', (e) => {
                if (e.code === 'Enter') {
                    this.click(e.currentTarget);
                } else if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
                    e.preventDefault();
                    this.navigateItems(e.code);
                } else if (e.code === 'Escape') {
                    this.close();
                }
            });
        }, this);
    }

    openAndFocusFirst() {
        if (!this.el.classList.contains('select--active')) {
            this.open();
        }

        if (this.items.length > 0) {
            this.items[0].focus();
        }
    }

    navigateItems(keyCode) {
        const currentlyFocused = document.activeElement;
        if (!currentlyFocused.classList.contains('select-item')) return;

        const currentIndex = Array.from(this.items).indexOf(currentlyFocused);

        let nextIndex = -1;
        if (keyCode === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % this.items.length;
        } else if (keyCode === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + this.items.length) % this.items.length;
        }

        if (nextIndex !== -1) {
            this.items[nextIndex].focus();
        }
    }

    click(el) {
        this.router.params.set(this.param, el.dataset.selectValue);
        el.dataset.filter ? this.router.params.set(this.primary ? 'filter' : 'filter2', el.dataset.filter) : this.router.params.delete(this.primary ? 'filter' : 'filter2');
        this.router.update();
        this.close();
    }

    toggle() {
        if (this.el.classList.contains('select--active')) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.el.classList.add('select--active');
        this.list.style.display = 'block';
        this.selected.setAttribute('aria-expanded', 'true');
        this.items.forEach((item) => item.setAttribute('tabindex', '0'));
        if (this.child) {
            this.child.el.classList.remove('select--active');
        }
    }

    close() {
        this.el.classList.remove('select--active');
        this.list.style.display = 'none';
        this.selected.setAttribute('aria-expanded', 'false');
        this.items.forEach((item) => item.setAttribute('tabindex', '-1'));
        this.selected.focus();
    }

    show() {
        const value = this.router.params.get(this.param);
        const el = [...this.items].find((item) => item.dataset.selectValue === value && !item.classList.contains('hide'));
        if (el) {
            !this.active(el) ? this.choose(el) : null;
        } else {
            this.reset();
        }

        if (this.child) {
            this.child.show();
        }
    }

    active(item) {
        return item.classList.contains('select-item--active');
    }

    choose(el) {
        const value = el.dataset.selectValue;
        const name = el.querySelector('.text').innerHTML;
        this.router.data.model = el;
        this.select.value = value;
        this.text.innerHTML = name;
        this.selected.classList.add('select-selected--active');
        this.list.classList.remove('select-item--active');
        this.items.forEach((item) => item.classList.remove('select-item--active'));
        el.classList.add('select-item--active');

        if (this.background) { this.background.set(el); }
        if (this.child) { this.child.filter(value); }

        AnalyticsHelper.template(this.select, { value: value, type: this.child ? "Category" : "Model" });
        AnalyticsHelper.push(this.select);
    }

    find(value) {
        return this.list.find((el) => el.dataset.selectValue === value);
    }

    filter(value) {
        const items = [...this.items];
        items.forEach((item) => item.dataset.parent !== value ? item.classList.add('hide') : item.classList.remove('hide'));
        items.every((item) => item.classList.contains('hide')) ? this.el.classList.add("disabled") :  this.el.classList.remove("disabled");
    }

    reset() {
        this.select.value = null;
        this.text.innerHTML = this.none;
        this.list.classList.remove('select-item--active');
        this.selected.classList.remove('select-selected--active');
        this.items.forEach((item) => item.classList.remove('select-item--active'));
        this.router.params.delete(this.param);
        this.router.update();

        if (this.child) {
            this.child.filter();
            this.child.reset();
        }
    }
}
